export const loyaltyInfo = {
  loyaltyInfo: "Loyalty Info",
  search: "Search",
  from: "From",
  to: "To",
  advanceFilter: "Advance Filter",
  selectAction: "SELECT ACTION",
  pointEarn: "POINT_EARN",
  pointBurn: "POINT_BURN",
  pointExpire: "POINT_EXPIRE",
  pointEarnRefund: "POINT_EARN_REFUND",
  pointAdjust: "POINT_ADJUST",
  selectRemark: "SELECT REMARK",
  turnOver: "TURN_OVER",
  manualTopup: "MANUAL_TOPUP",
  deductRedeem: "DEDUCT_POINT",
  redeem: "REDEEM",
  close: "close",
  filter: "filter",
  action: "ACTION",
  username: "USERNAME",
  openAmount: "Open Amount",
  closeAmount: "Close Amount",
  remark: "Remarks",
  createdDate: "Created Date",
  amount: "AMOUNT",
};
